import React from 'react';

import WBSlateReduxBridge from '../../components/Slate/WBSlateReduxBridge';
import {useLoadedReportContext} from './LoadedReportContext';
import {useReportPageContext} from './ReportPageContext';
import {ReportMode} from './types';

export const ReportPageContent = () => {
  const {projectName, entityName, reportMode, viewedReportId} =
    useReportPageContext();
  const {reportViewRef, view} = useLoadedReportContext();

  return (
    <WBSlateReduxBridge
      entityName={entityName}
      projectName={projectName ?? ''}
      viewId={viewedReportId}
      readOnly={reportMode === ReportMode.IS_VIEWING}
      viewRef={reportViewRef}
      view={view}
    />
  );
};
